import type { ParseKeys } from "i18next";
import {
  Activity,
  FileKey2,
  History,
  House,
  KeyRound,
  type LucideIcon,
  Settings,
  ShieldCheck,
  Users,
} from "lucide-react";

import type { Access } from "@/auth/access";
import { paths } from "@/routes/paths";

export interface NavItem {
  labelKey: ParseKeys<"nav">;
  href: string;
  icon: LucideIcon;
  access: Access;
  /** Solo activa con la ruta exacta (Inicio). */
  end?: boolean;
}

export interface NavSection {
  titleKey?: ParseKeys<"nav">;
  items: NavItem[];
}

/**
 * Barra lateral de la organización (propuesta de UX aprobada). Cada entrada se
 * ve solo si `canAccess(session, access)`. Plataforma no está aquí: se entra
 * desde el menú de usuario.
 */
export const navSections: NavSection[] = [
  {
    items: [
      {
        labelKey: "home",
        href: paths.home,
        icon: House,
        access: "admin",
        end: true,
      },
      {
        labelKey: "certificates",
        href: paths.certificates,
        icon: KeyRound,
        access: "admin",
      },
      {
        labelKey: "policies",
        href: paths.policies,
        icon: ShieldCheck,
        access: "admin",
      },
      { labelKey: "people", href: paths.people, icon: Users, access: "admin" },
      {
        labelKey: "activity",
        href: paths.activity,
        icon: Activity,
        access: "admin",
      },
    ],
  },
  {
    titleKey: "sectionMe",
    items: [
      {
        labelKey: "myCertificates",
        href: paths.myCertificates,
        icon: FileKey2,
        access: "member",
      },
      {
        labelKey: "myActivity",
        href: paths.myActivity,
        icon: History,
        access: "member",
      },
    ],
  },
  {
    titleKey: "sectionSettings",
    items: [
      {
        labelKey: "organization",
        href: paths.organization,
        icon: Settings,
        access: "admin",
      },
    ],
  },
];
